var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSales1 = function SvgSales1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.028 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.175 40.382a3.26 3.26 0 0 0-1.273-4.434 36 36 0 0 0-5.667-2.518 18.78 18.78 0 1 0-23.437 0 36.3 36.3 0 0 0-9.289 4.8A38.03 38.03 0 0 0 .215 55.564a3.265 3.265 0 0 0 6.1 2.328 31.5 31.5 0 0 1 11-14.364 29.36 29.36 0 0 1 31.427-1.883 3.26 3.26 0 0 0 4.433-1.263m-18.661-33.6a12 12 0 1 1-12 12 12.01 12.01 0 0 1 12-11.998ZM67.071 48.788h-5.34v-5.34a1.957 1.957 0 1 0-3.914 0v5.34h-5.34a1.957 1.957 0 1 0 0 3.914h5.34v5.34a1.957 1.957 0 1 0 3.914 0v-5.34h5.34a1.957 1.957 0 0 0 0-3.914"
  }))));
};
export default SvgSales1;